<template>
  <span class="consumption-info-popover" v-if="consumption">
    <slot name="txtBefore"></slot>
    <BIconInfoCircleFill class="info-icon" :class="`infoIcon${ consumption.type }`" :id="`popover-target${ consumption.type }`"></BIconInfoCircleFill>
    <b-popover :target="`popover-target${ consumption.type }`" triggers="click blur" placement="bottom">
      <template #title><slot name="popoverTitle">Zusammensetzung</slot></template>
      <div class="popover-content">
        <div class="popover-element" v-for="tariffOrOption in sortedTariffsOrOptions" :key="tariffOrOption.id">
          <div class="tariffs-with-consumpitons-name">{{ tariffOrOption.name }}</div>
          <div class="tariffs-with-consumpitons-used">{{ tariffOrOption.consumptions[0].description }}</div>
          <div class="tariffs-with-consumpitons-expiration">Gültig bis: {{ formatDate(tariffOrOption.consumptions[0].expirationDate) }}</div>
        </div>
      </div>
      <div class="popover-footer">
        <span class="popover-footer-title"><slot name="popoverFooter">Gesamt</slot></span>
        <span v-if="consumption.unit === 'UNLIMITED'" class="popover-footer-sum"> unbegrenzt</span>
        <span v-else class="popover-footer-sum">{{ formatNumber(consumption.max) }} {{ consumption.formattedUnit }}</span>
        <div class="popover-footer-summary"><slot name="popoverConsumed">{{ consumption.description }}</slot></div>
      </div>
    </b-popover>
    <slot name="txtAfter"></slot>
  </span>
</template>

<script>
import { BIconInfoCircleFill } from 'bootstrap-vue'

export default {
  name: 'ConsumptionInfoPopoverWithDescription',
  mixins: [
  ],
  components: { BIconInfoCircleFill },
  props: {
    consumption: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    formatDate (date) {
      if (this.$config?.calendar?.formatter?.dateFormatter === null) {
        return '-'
      }
      return this.$config.calendar.formatter.dateFormatter.format(new Date(date))
    },
    formatNumber (number) {
      if (this.$config?.calendar?.formatter?.numberFormatter === null) {
        return '-'
      }
      return this.$config.calendar.formatter.numberFormatter.format(number)
    }
  },
  computed: {
    sortedTariffsOrOptions () {
      const toSort = this.consumption.tariffOrOptions
      return toSort.sort((a, b) => {
        if (a.type !== b.type) {
          if (a.type === 'Tariff') {
            return -1
          }
          return 1
        }
        return 0
      })
    }
  }
}

</script>
